class CommandCommentModel {
    text = '';

    toString(i) {
        return this.text;
    }
}

export default CommandCommentModel;